import { csrfToken } from 'application/utils/csrf-request'

declare global {
  interface Window {
    ym?: (..._args: unknown[]) => void
  }

  // eslint-disable-next-line no-var, no-shadow
  var sendEvent: (_eventName: string, _params?: Record<string, unknown>) => void
}

/**
 * Отправляет достижение цели в Яндекс.Метрику
 *
 * @param {string} goalName - Идентификатор цели
 */
export function reachGoal(goalName: string): void {
  try {
    window.ym?.(23471596, 'reachGoal', goalName)
  } catch {
    // Analytics must not interrupt opening or confirming a booking.
  }
}

/**
 * Цель Метрики на клик по элементу с data-goal (телефоны в шапке, футере, у квеста)
 */
export function initGoalClicks(): void {
  document.addEventListener('click', (event) => {
    const target = (event.target as Element | null)?.closest?.<HTMLElement>(
      '[data-goal]'
    )
    if (target?.dataset.goal) reachGoal(target.dataset.goal)
  })
}

/**
 * Сохраняет событие с фронта в tracking_events
 *
 * @param {string} eventName - Название события
 * @param {Record<string, unknown>} params - Параметры события
 */
export function sendEvent(
  eventName: string,
  params: Record<string, unknown> = {}
): void {
  try {
    const token = csrfToken()
    fetch('/api/tracking_events', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...(token ? { 'X-CSRF-Token': token } : {})
      },
      credentials: 'same-origin',
      keepalive: true,
      body: JSON.stringify({
        // eslint-disable-next-line camelcase
        event_name: eventName,
        url: window.location.href,
        params
      })
    }).catch(() => {})
  } catch {
    // Analytics must not interrupt the user action.
  }
}

/**
 * ClientID Яндекс.Метрики из cookie _ym_uid — передаётся на бек, чтобы
 * привязать к нему цель new_BookingFinal, отправляемую с бека при is_booked=true
 * (см. Order#claim_yandex_final_goal!, недоступную для клиентского ym()).
 *
 * @return {string} ClientID или пустая строка, если счётчик ещё не проставил cookie
 */
export function getYandexClientId(): string {
  const match = document.cookie.match(/(?:^|;\s*)_ym_uid=([0-9]{1,64})(?:;|$)/)

  return match ? match[1] : ''
}
